export default () => crypto.randomUUID().replaceAll('-', '')
